// client/src/components/EbayItemSpecifics.js
import React from "react";
import { Form, Row, Col } from "react-bootstrap";

/**
 * eBay Item Specifics Editor Component
 * Dynamically renders item-specific fields for any eBay category.
 * @param {Array} specifics - Array of { Name, Value }
 * @param {Function} onChange - Callback(Name, newValue)
 */
export default function EbayItemSpecifics({ specifics = [], onChange }) {
  if (!specifics.length) {
    return (
      <p className="text-muted">
        No item specifics found for this product.
      </p>
    );
  }

  return (
    <div className="ebay-specifics-section mt-3">
      <h5 className="mb-3">eBay Item Specifics</h5>
      <Row>
        {specifics.map((spec, index) => (
          <Col md={6} key={index} className="mb-3">
            <Form.Group controlId={`specific-${index}`}>
              <Form.Label>{spec.Name}</Form.Label>
              <Form.Control
                type="text"
                value={spec.Value || ""}
                onChange={(e) => onChange(spec.Name, e.target.value)}
              />
            </Form.Group>
          </Col>
        ))}
      </Row>
    </div>
  );
}
